require("!!/opt/app/develop/node_modules/script-loader/addScript.js")(require("!!/opt/app/develop/node_modules/raw-loader/index.js!/opt/app/develop/node_modules/bootstrap/dist/js/bootstrap.min.js"))


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/script-loader!/opt/app/develop/~/bootstrap/dist/js/bootstrap.min.js
// module id = ../../../../script-loader/index.js!../../../../bootstrap/dist/js/bootstrap.min.js
// module chunks = 3